import React from 'react';
import CircularProgress from 'components_base/CircularProgress';

const CalculationFast = React.lazy(() => import('../components/CalculationFast'));

function CalculationCreateView(props: any) {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <CalculationFast />
    </React.Suspense>
  );
}

export default CalculationCreateView;
